export function isCustomPatientSession(session) {
  return Boolean(session?.custom_patient_id) || session?.is_custom_patient === true;
}

export function getSessionPatientDisplayName(session) {
  const name = session?.persona_name;
  return name && String(name).trim() ? String(name).trim() : 'Patient';
}

/** Anatomage Patients: "#12". My Patients: "C". */
export function getSessionPatientIdLabel(session) {
  if (isCustomPatientSession(session)) return 'C';
  if (session?.persona_character_id != null && session.persona_character_id !== '') {
    return `#${session.persona_character_id}`;
  }
  return null;
}
